export default {
      id: "arrow-usage",
      viewBox: "0 0 9 6",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }